// extracted by mini-css-extract-plugin
module.exports = {"root":"SnsShareArea_root__3GebV","twitter":"SnsShareArea_twitter__1IBn5","facebook":"SnsShareArea_facebook__15jKE","line":"SnsShareArea_line__2Mjkw"};